export default __webpack_public_path__ + "static/media/arrowRight.aa2fd083.svg";